import * as types from '../mutation-types';

const state = {
  msisdn: '',
  clientType: '',
  clientBalance: '',
  creditLine: false,
  hasCreditCard: true,
  clientMobileData: '',
  applyToLoan: false,
  applyToSponsorship: false,
  clientProfile: ''
};

const getters = {
  msisdn: () => state.msisdn,
  clientType: () => state.clientType,
  creditLine: () => state.creditLine,
  clientBalance: () => state.clientBalance,
  hasCreditCard: () => state.hasCreditCard,
  clientMobileData: () => state.clientMobileData,
  applyToLoan: () => state.applyToLoan,
  applyToSponsorship: () => state.applyToSponsorship,
  clientProfile: () => state.clientProfile
};

const actions = {
  setMsisdn: ({ commit }, msisdn) => {
    commit(types.SET_MSISDN, msisdn);
  },
  setClientType: ({ commit }, clientType) => {
    commit(types.SET_PROFILE_TYPE, clientType);
  },
  usingCreditCard: ({ commit }, status) => {
    commit(types.SET_USING_CREDIT_CARD, status);
  },
  setClientBalance: ({ commit }, clientBalance) => {
    commit(types.SET_BALANCE, clientBalance);
  },
  setClientMobileData: ({ commit }, clientMobileData) => {
    commit(types.SET_MOBILE_DATA, clientMobileData);
  },
  setCreditLine: ({ commit }, status) => {
    commit(types.SET_CREDIT_LINE, status);
  },
  setApplyToLoan: ({ commit }, applyToLoan) => {
    commit(types.SET_APPLY_TO_LOAN, applyToLoan);
  },
  setApplyToSponsorship: ({ commit }, applyToSponsorship) => {
    commit(types.SET_APPLY_TO_SPONSORSHIP, applyToSponsorship);
  },
  setClientProfile: ({ commit }, profile) => {
    commit(types.SET_CLIENT_PROFILE, profile);
  },
  resetClientValues: ({ dispatch }) => {
    dispatch('setClientBalance', false);
    dispatch('setCreditLine', false);
    dispatch('setClientMobileData', false);
    dispatch('setApplyToLoan', false);
    dispatch('setApplyToSponsorship', false);
  }
};

const mutations = {
  [types.SET_MSISDN](_, msisdn) {
    state.msisdn = msisdn;
  },
  [types.SET_PROFILE_TYPE](_, clientType) {
    state.clientType = clientType;
  },
  [types.SET_USING_CREDIT_CARD](_, status) {
    state.hasCreditCard = status;
  },
  [types.SET_BALANCE](_, clientBalance) {
    state.clientBalance = clientBalance;
  },
  [types.SET_MOBILE_DATA](_, clientMobileData) {
    state.clientMobileData = clientMobileData;
  },
  [types.SET_CREDIT_LINE](_, status) {
    state.creditLine = status;
  },
  [types.SET_APPLY_TO_LOAN](_, applyToLoan) {
    state.applyToLoan = applyToLoan;
  },
  [types.SET_CLIENT_PROFILE](_, profile) {
    state.clientProfile = profile;
  },
  [types.SET_APPLY_TO_SPONSORSHIP](_, applyToSponsorship) {
    state.applyToSponsorship = applyToSponsorship;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/client.js